import React from 'react'
import { connect } from 'react-redux';

const ThinkingTalentsFullReportItem = (props) => {
  const { item } = props;

  return (
    <div className="talents-item text-center mb-2 p-2">
      <div>
        <div id={`talent-${item.id}`} className='mx-auto d-inline-block p-2'>
          <img className="media-object" width="36" height="36" src={item.icon_invert} alt={item.name} />
        </div>
        <p className='mb-1 small font-weight-semibold'>{item.name}</p>
        <div>
          <div className='rounded-circle bg-always p-1 d-inline-block badge-talent'>
            <span className='small font-weight-semibold'>{item.total_members}</span>
          </div>
          <div className='rounded-circle bg-never p-1 d-inline-block badge-talent'>
            <span className='small font-weight-semibold'>{item.total_members_energy_never}</span>
          </div>
        </div>
      </div>
    </div>
  )

}

const mapStateToProps = (state, props) => {
  const { user } = state;
  return {
    user
  };
};

const mapDispatchToProps = {
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThinkingTalentsFullReportItem);
